import axios, { AxiosError } from 'axios'
import { useMutation } from 'react-query'

import { BirthdayOrderRequest, BirthdayOrderResponse } from '@facades/birthday'
import { getEndpoint } from '@utils/getEndpoint'

const createBirthdayOrder = async (
  order: BirthdayOrderRequest
): Promise<BirthdayOrderResponse> => {
  const response = await axios.post<BirthdayOrderResponse>(
    `${getEndpoint()}/birthday/orders`,
    order
  )
  return response.data
}

export const useCreateBirthdayOrder = () =>
  useMutation<BirthdayOrderResponse, AxiosError, BirthdayOrderRequest>(
    createBirthdayOrder
  )
